import _extends from "@babel/runtime/helpers/extends";
import { createMemoryHistory } from 'history';
import React, { useMemo, useEffect } from 'react';
import { invokePluginLoad } from '../../controllers/plugins/index';
import { createResourcesPlugin } from '../../resources/plugin';
import { getRouterState, RouterContainer } from '../router-store';
export const Router = _ref => {
  let {
    basePath,
    children,
    history,
    initialRoute,
    isGlobal = true,
    plugins,
    onPrefetch,
    resourceContext,
    resourceData,
    routes
  } = _ref;
  useEffect(() => {
    const {
      unlisten
    } = getRouterState();
    return () => {
      unlisten && unlisten();
    };
  }, []);
  const pluginsWithFallback = useMemo(() => {
    if (plugins) return plugins; // default 'plugins' fallback for the first relase

    const resourcesPlugin = createResourcesPlugin({
      context: resourceContext,
      resourceData
    });
    return [resourcesPlugin];
  }, [resourceContext, resourceData, plugins]);
  return /*#__PURE__*/React.createElement(RouterContainer, {
    basePath: basePath,
    history: history,
    initialRoute: initialRoute,
    isGlobal: isGlobal,
    onPrefetch: onPrefetch,
    plugins: pluginsWithFallback,
    resourceContext: resourceContext,
    resourceData: resourceData,
    routes: routes
  }, children);
};
/**
 * @deprecated
 * The entry point for requesting resource data on the server.
 * Pass the result data into the router as a prop in order to hydrate it.
 */

Router.requestResources = async _ref2 => {
  let {
    location,
    history,
    timeout,
    routes,
    resourceContext: context
  } = _ref2;
  const resourcesPlugin = createResourcesPlugin({
    context,
    resourceData: null,
    timeout
  });
  const plugins = [resourcesPlugin];
  invokePluginLoad(plugins, {
    history: history || createMemoryHistory({
      initialEntries: [location]
    }),
    routes: routes
  });
  return await resourcesPlugin.getSerializedResources();
};

export function MemoryRouter(props) {
  const history = useMemo(() => createMemoryHistory(props.location ? {
    initialEntries: [props.location]
  } : {}), [props.location]);
  return /*#__PURE__*/React.createElement(Router, _extends({}, props, {
    history: history,
    isGlobal: false
  }));
}